/* eslint-disable */
let config;

if (process.env.NODE_ENV === 'dev') {
  config = require('./test');
}

if (process.env.NODE_ENV === 'test') {
  config = require('./test');
}

if (process.env.NODE_ENV === 'production') {
  config = require('./production');
}

export default config;


// WEBPACK FOOTER //
// ./src/config/index.js